import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import PencilRulerIcon from '@v4/components/common/FAIcons/Light/PencilRuler'
import { useThemeButton } from './ThemeButton.hooks'

const ThemeButton = props => {
	const [{ classes, className }, { handleClick }] = useThemeButton(props)

	return (
		<button type="button" className={clsx(classes.root, className)} onClick={handleClick}>
			<PencilRulerIcon className={classes.icon} />
			Edit page design
		</button>
	)
}

ThemeButton.propTypes = {
	className: PropTypes.string,
}

export default memo(ThemeButton)
